import React from 'react';
import {Globe, Mail, Megaphone} from 'lucide-react';
import './social-icons.css';

const networks:Record<string,{name:string;asset:string}>={
 instagram:{name:'Instagram',asset:'instagram-source.svg'},
 facebook:{name:'Facebook',asset:'facebook.svg'},
 tiktok:{name:'TikTok',asset:'tiktok.svg'},
 linkedin:{name:'LinkedIn',asset:'linkedin.svg'},
 youtube:{name:'YouTube',asset:'youtube.svg'},
 x:{name:'X',asset:'x-source.svg'},
};

/** The same local brand asset is used in editorial content and API connections. */
export function SocialIcon({channel,decorative=false}:{channel:string;decorative?:boolean}){
 const key=channel.trim().toLowerCase().replace(/\s+/g,''),network=networks[key==='twitter'||key==='x(twitter)'?'x':key];
 const Fallback=key==='email'?Mail:key==='googleads'?Megaphone:Globe;
 return <span className={'social social-brand social-brand-'+(network?network.name.toLowerCase():key)} role={decorative?undefined:'img'} aria-label={decorative?undefined:network?.name||channel} aria-hidden={decorative||undefined}>
  {network?<img src={'/social/'+network.asset} alt="" aria-hidden="true" width="24" height="24"/>:<Fallback size={15} aria-hidden="true"/>}
 </span>;
}
